import { FncoPriceSupplySnapshot } from '@/components/Approval/@components/FncoPriceSupply';
import { parseFncoPriceSupplyContent } from '@/utils/approval/fncoPriceSupply';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 197~199 가격 등록 공급가·할인율·판매가 요청 — 저장 content 그대로(레거시 문서 포함). SAP 재조회 안 함 */
const FncoPriceSupplySlot = ({ data }: ContentExtraProps) => {
  const content = parseFncoPriceSupplyContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <FncoPriceSupplySnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default FncoPriceSupplySlot;
